import { CellSimple, Counter } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const CellSimpleTappableExample = {
  title: "CellSimple - Tappable",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [],

  Preview() {
    return (
      <CellSimple
        after={<Counter key="counter" value={1200}/>}
        before={<PlaceholderIcon />}
        height="normal"
        onClick={() => {}}
        showChevron
        subtitle="Subtitle"
        title="Title"
      />
    )
  },

  getCode() {
    return `<CellSimple
  after={<Counter key="counter" value={1200}/>}
  before={<Icon24Placeholder />}
  height="normal"
  onClick={() => {}}
  showChevron
  subtitle="Subtitle"
  title="Title"
/>`
  },
}